<template>
  <div id='LoginPage' class="container-fluid h-100 p-0 m-0">
    <div class="row h-100 align-items-center p-0 m-0">
      <!-- FORMS SIDE -->
      <div class="col-12 col-lg-7 col-xl-6 p-0 m-0">

        <div class="px-5 px-md-5 mx-md-5" style="max-width: 600px;">

          <!-- LOGO -->
          <div class="row">
            <div class="col-12">
              <Logo style="width: 80px; height: 80px;" />
            </div>
          </div>

          <!-- LOGIN FORM -->
          <form class="row justify-content-center align-items-center" v-if="!forgotPassword && !otpForm && !passwordExpired"
            @submit.prevent="login">
            <!-- Title -->
            <div class="col-12 login-title px-4">
              <h4>
                {{ $t("login.pageTitle") }}
              </h4>
            </div>

            <!-- Fields -->
            <div class="col-12 input-with-icon mb-3 px-4 pb-2">
              <input v-model="email" type="email" name="email" :placeholder="$t('formFields.email')" required />
              <i class="fa fa-envelope" aria-hidden="true"></i>
            </div>

            <div class="col-12 input-with-icon mb-3 px-4 pb-2">
              <input v-model="password" type="password" name="password" :placeholder="$t('formFields.password')"
                required />
              <i class="fa fa-lock" aria-hidden="true"></i>
            </div>

            <div class="col-12 forgot-password-text mb-3 px-4">
              <span style="cursor: pointer; width: auto" @click="forgotPassword = true">
                <p>{{ $t("login.forgotPasswordQuestion") }}</p>
              </span>
            </div>

            <!-- Container -->
            <div class="flex flex-wrap md:flex-nowrap space-y-4 md:space-y-0">

              <!-- Submit -->
              <div class="w-full md:w-1/2 px-4 mt-4">
                <CustomButton :btnText="$t('btns.connect')" type="submit" btn-type="nextgen" />
              </div>

              <!-- Prosante -->
              <div class="flex justify-center px-4 mt-4">
                <button id="psc-logo-link" @click="prosanteLogin">
                  <img class="w-[200px]" :src="$icons.psc" alt="prosanteconnect">
                </button>
              </div>
            </div>
          </form>

          <!-- FORGOT PASSWORD FORM -->
          <form class="row justify-content-center align-items-center" v-if="forgotPassword"
            @submit.prevent="requestPasswordReset">

            <!-- Title -->
            <div class="col-12 login-title px-4">
              <h4>
                {{ $t("login.forgotPasswordPrompt") }}
              </h4>
            </div>

            <!-- Fields -->
            <div class="col-12 input-with-icon mb-3 px-4 pb-2">
              <input v-model="recoveryEmail" type="email" name="email" :placeholder="$t('formFields.email')" required />
              <i class="fa fa-envelope" aria-hidden="true"></i>
            </div>

            <div class="col-12 forgot-password-text mb-3 px-4">
              <span style="cursor: pointer" @click="forgotPassword = false">
                <p>
                  {{ $t("login.backToConnection") }}
                </p>
              </span>
            </div>

            <!-- Submit -->
            <div class="col-12 px-4 mt-4">
              <CustomButton :btnText="$t('btns.send')" class="mt-4" type="submit" btn-type="nextgen" />
            </div>

          </form>

          <!-- EXPIRED PASSWORD FORM -->
          <form class="row justify-content-center align-items-center" v-if="passwordExpired"
            @submit.prevent="changeExpiredPassword">
            <!-- Title -->
            <div class="col-12 login-title px-4">
              <h4>
                {{ expiredPasswordOtpSent ? $t("login.expiredPasswordOtpPrompt") : $t("login.passwordExpiredPrompt") }}
              </h4>
            </div>

            <!-- Fields -->
            <div class="col-12 input-with-icon mb-3 px-4 pb-2">
              <input v-model="newPassword" type="password" name="newPassword"
                :placeholder="$t('security.newPassword')" required />
              <i class="fa fa-lock" aria-hidden="true"></i>
            </div>

            <div class="col-12 input-with-icon mb-3 px-4 pb-2">
              <input v-model="confirmPassword" type="password" name="confirmPassword"
                :placeholder="$t('security.confirmPassword')" required />
              <i class="fa fa-lock" aria-hidden="true"></i>
            </div>

            <!-- Only once an SMS has been sent. The password fields stay editable, so a new
                 password refused for reuse can be retried on the same code. -->
            <div class="col-12 input-with-icon mb-3 px-4 pb-2" v-if="expiredPasswordOtpSent">
              <input v-model="otp" type="number" name="otp" :placeholder="$t('formFields.otp')" required />
              <i class="fa fa-lock" aria-hidden="true"></i>
            </div>

            <div class="col-12 forgot-password-text mb-3 px-4">
              <span style="cursor: pointer" @click="backToConnection">
                <p>
                  {{ $t("login.backToConnection") }}
                </p>
              </span>
            </div>

            <!-- Submit -->
            <div class="col-12 px-4 mt-4">
              <CustomButton :btnText="$t('btns.confirm')" class="mt-4" type="submit" btn-type="nextgen" />
            </div>

          </form>

          <!-- OTP FORM -->
          <form class="row justify-content-center align-items-center" v-if="otpForm" @submit.prevent="loginWithOtp">
            <!-- Title -->
            <div class="col-12 login-title px-4">
              <h4>
                {{ $t("login.otpPrompt") }}
              </h4>
            </div>

            <!-- Fields -->
            <div class="col-12 input-with-icon mb-3 px-4 pb-2">
              <input v-model="otp" type="number" name="otp" :placeholder="$t('formFields.otp')" required />
              <i class="fa fa-lock" aria-hidden="true"></i>
            </div>

            <div class="col-12 forgot-password-text mb-3 px-4">
              <span style="cursor: pointer" @click="otpForm = false">
                <p>
                  {{ $t("login.backToConnection") }}
                </p>
              </span>
            </div>

            <!-- Submit -->
            <div class="col-12 px-4 mt-4">
              <CustomButton :btnText="$t('btns.connect')" class="mt-4" type="submit" btn-type="nextgen" />
            </div>

          </form>

          <!-- MADE BY -->
          <div class="row pt-5">
            <div class="col-12 px-4">
              <div class="flex no-wrap">
                <span>
                  {{ $t("login.productOf") }}
                  <a class="mr-1" href="https://zedsoft.co.uk/" target="_blank">
                    <b>Zedsoft</b>
                  </a>
                </span>
                <img src="/assets/images/zedsoft-logo.png" alt="zedsoft logo" class="w-4"
                  style="object-fit: contain;" />
              </div>
            </div>
          </div>

        </div>

      </div>

      <!-- PICTURE SIDE -->
      <div class="d-none d-lg-flex col-5 col-xl-6 h-100 p-0 m-0">
        <img class="h-100 w-100" style="object-fit: cover;" src="../assets/img/login.jpeg" />
      </div>

    </div>
  </div>
</template>

<script>
import { sha256 } from "js-sha256";
import {
  REQUESTS,
  apiAuth,
  buildRequest,
  machineIdGen,
  apiMain,
  errorHandler,
  apiTeleservices,
} from "../components/Javascript/methods";
import axios from "@/axiosClient";
import Logo from "@/components/Logo.vue";
import CustomButton from "@/components/CustomButton.vue";
import { flagInvalidInput } from "@/components/Javascript/invalidFields";

export default {
  name: "Login",
  data() {
    return {
      errorHandler,
      email: "",
      recoveryEmail: "",
      password: "",
      forgotPassword: false,
      otpForm: false,
      otp: "",
      passwordExpired: false,
      newPassword: "",
      confirmPassword: "",
      expiredPasswordOtpSent: false,
      passwordRegex: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&.])[A-Za-z\d@$!%*#?&.]{8,}$/,
    };
  },
  beforeMount() {
    this.$Progress.start();
  },
  async mounted() {
    document.title = this.$t("tabTitle.login");
    // prosante link
    const state = this.$route.query.state;
    const session_state = this.$route.query.session_state;
    const code = this.$route.query.code;
    if (state && session_state && code) {
      await this.loginWithProsante(state, session_state, code);
    }
    this.$Progress.finish();
  },
  methods: {
    async login() {
      const apiLogin = apiAuth + "/login";
      const body = {
        email: this.email,
        auth_machine_id: machineIdGen(),
        password: sha256(this.password).toString(),
        locale: this.$store.state.locale,
      };
      var config = buildRequest(REQUESTS.POST, apiLogin, body);
      await axios(config)
        .then((response) => {
          if (response.data.passwordExpired) {
            this.passwordExpired = true;
          }
          else if (response.data.otpSent) {
            this.otpForm = true;
          }
          else {
            this.$store.dispatch("changeTokens", {
              access_token: response.data.access_token,
              refresh_token: response.data.refresh_token,
            });
            this.$store.dispatch("changeUid", response.data.uid);
            this.$store.dispatch("changeMachineId", body.auth_machine_id);
            if (this.$store.state.nextUrl) {
              this.$router.push({ path: this.$store.state.nextUrl });
              this.$store.dispatch("changeNextUrl", null);
            }
            else {
              this.goToPage("dashboard");
            }
          }
        })
        .catch((error) => {
          this.errorHandler(error);
        });
    },
    backToConnection() {
      this.passwordExpired = false;
      this.expiredPasswordOtpSent = false;
      this.password = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.otp = "";
    },
    // The password the operator typed on the login form is the current one, so
    // this form only asks for the replacement.
    //
    // On an account with a second factor the first submit changes nothing: auth
    // texts a code and answers { otpSent: true }, and the same request has to come
    // back carrying it. From then on every submit carries the code, so a retry
    // never costs another SMS.
    async changeExpiredPassword() {
      if (!this.passwordRegex.test(this.newPassword)) {
        this.errorPop("toasts.passwordComplexity");
        flagInvalidInput(this.$el.querySelector('input[name="newPassword"]'));
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.errorPop("toasts.passwordsDoNotMatch");
        flagInvalidInput(this.$el.querySelector('input[name="confirmPassword"]'));
        return;
      }

      const apiRoute = apiAuth + "/change-expired-password";
      const body = {
        email: this.email,
        password: sha256(this.password).toString(),
        new_password: sha256(this.newPassword).toString(),
        locale: this.$store.state.locale,
      };
      if (this.expiredPasswordOtpSent) {
        body.otp_code = String(this.otp).padStart(6, "0");
      }
      var config = buildRequest(REQUESTS.POST, apiRoute, body);
      await axios(config)
        .then((res) => {
          if (res.data.otpSent) {
            // Blank, so a code left over from the login OTP form is not sent as this one.
            this.otp = "";
            this.expiredPasswordOtpSent = true;
            return;
          }

          // Nothing short of { changed: true } means the password was replaced.
          if (!res.data.changed) {
            this.errorPop("toasts.somethingWentWrong");
            return;
          }

          this.successPop("toasts.successRequest", res.config.url.split("/").at(-1));
          this.backToConnection();
        })
        .catch((error) => {
          this.errorHandler(error);
        });
    },
    prosanteLogin() {
      this.$store.dispatch("changeNextUrl", this.$route.path);
      window.location.href = apiTeleservices + "/auth";
    },
    async loginWithProsante(state, session_state, code) {
      // Recupere l'utilisateur via Prosante
      const req = buildRequest(
        REQUESTS.GET,
        apiMain + "/get-prosante-user",
        { state, session_state, code },
        true
      );

      await axios(req)
        .then(async (res) => {
          // The handshake proves who this is, so what comes back is a single-use
          // code rather than a credential. It is spent on the OTP route, which
          // already trades a code for a session.
          this.email = res.data.user_email;
          this.otp = res.data.login_code;
          this.$router.replace({ path: this.$route.path, query: {} });

          await this.loginWithOtp();
        })
        .catch((error) => {
          this.errorHandler(error);
        });
    },
    async requestPasswordReset() {
      const apiRoute = apiMain + "/request-password-reset";
      const body = {
        email: this.recoveryEmail,
        locale: this.$store.state.locale,
      };
      var config = buildRequest(REQUESTS.PUT, apiRoute, body);
      axios(config)
        .then((response) => {
          if (response.data.sent) {
            this.successPop("toasts.success", response.config.url.split("/").at(-1));
            this.forgotPassword = false;
          }
        })
        .catch((error) => {
          this.errorHandler(error);
        });
    },
    async loginWithOtp() {
      const apiLogin = apiAuth + "/login-with-otp";
      const body = {
        email: this.email,
        auth_machine_id: machineIdGen(),
        otp_code: String(this.otp).padStart(6, "0"),
      };
      var config = buildRequest(REQUESTS.POST, apiLogin, body);
      await axios(config)
        .then((response) => {
          if (response.data.passwordExpired) {
            this.otpForm = false;

            // The expired-password form verifies the current one, and a Pro Sante Connect
            // sign-in never asked for it - so offering that form would be a screen the user
            // cannot get out of. The reset link is the way through.
            if (!this.password) {
              this.errorPop("toasts.passwordExpiredUseReset");
              return;
            }

            this.passwordExpired = true;
            return;
          }

          this.$store.dispatch("changeTokens", {
            access_token: response.data.access_token,
            refresh_token: response.data.refresh_token,
          });
          this.$store.dispatch("changeUid", response.data.uid);
          this.$store.dispatch("changeMachineId", body.auth_machine_id);

          if (this.$store.state.nextUrl) {
            this.$router.push({ path: this.$store.state.nextUrl });
            this.$store.dispatch("changeNextUrl", null);
          }
          else {
            this.goToPage("dashboard");
          }
        })
        .catch((error) => {
          this.errorHandler(error);
        });
    },
  },
  components: { Logo, CustomButton }
};
</script>

<style scoped>
.login-title {
  height: 50px;
  margin-bottom: 30px;
}

input {
  padding-left: 15% !important;
}

.input-with-icon {
  position: relative;
}

.input-with-icon i {
  position: absolute;
  left: 12%;
  top: 32%;
  opacity: 0.3;
  color: #000;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
